import { Flight } from '@ibe/models';

/**
 * State for the CountryCodes
 *
 * @export
 * @class State
 */
export class State {
	loading: false;
	selectedFlight: Flight;
}

export const initialState: State = {
	loading: false,
	selectedFlight: null
};
